import React from "react";
import {StyledTemplateCard} from "./TemplateCard.style";
import landingPage2 from "../../../../assets/WebsiteBuilder/landingPage2.jpg";
import {CgEye} from "react-icons/cg";
import Button from "components/molecules/Button";
import ModalContainer from "components/molecules/ModalContainer";
import PreviewModal from "./PreviewModal";
import {useNavigate} from "react-router-dom";

const tabs = ["Grid Layout", "Modern UI", "Responsive Design"];

const TemplateCard = ({data}) => {
    const navigate = useNavigate();
    return (
        <StyledTemplateCard>
            <div className="img-wrap">
                <img src={data?.banner} alt="banner" className="bannerImg" />
                <div className="btn-wrap">
                    <ModalContainer
                        width="993"
                        title={`${data?.title} - Preview`}
                        content={({onClose}) => <PreviewModal />}
                        btnComponent={({onClick}) => (
                            <Button width="119px" variant="secondary" className="preview-btn" onClick={onClick}>
                                <CgEye color="rgba(119, 119, 119, 1)" />
                                Preview
                            </Button>
                        )}
                    />

                    <Button width="157px" onClick={() => navigate("/website-builder/template")}>
                        Select Template
                    </Button>
                </div>
            </div>
            <div className="details-wrap">
                <div className="template-head">
                    <strong className="template-title">{data?.title}</strong>
                    <span className="template-label">{data?.label}</span>
                </div>
                <p className="desc">{data?.desc}</p>
                <ul className="tabs-wrap">
                    {data?.tabs?.map((item, index) => (
                        <li className="tab" key={index}>
                            {item}
                        </li>
                    ))}
                </ul>
            </div>
        </StyledTemplateCard>
    );
};

export default TemplateCard;
